<template>
  <div>
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
        :z-index="10000000"
        background-color="#000"
        color="#fff"
      ></loading>
    </div>
    <!-- <transition name="right">
      <div class="filter text-white" v-if="filterDisplay">
        <div class="filter-header grid grid-cols-3">
          <font-awesome-icon icon="times" class="close" @click="closeFilter" />
          <h2 class="text-white text-center">Filter By</h2>
        </div>
        <div class="filter-input">
          <label>Start Date</label>
          <div class="col-span-4 mb-5">
            <v-date-picker
              class="date-picker w-full"
              is-dark
              v-model="startDate"
              @dayclick="loadFilteredTable"
              is-required
            >
              <template v-slot="{ inputEvents }">
                <div class="date w-full">
                  <input
                    type="button"
                    class="date-input w-full text-left"
                    v-on="inputEvents"
                    :value="formattedStartDate"
                  />
                </div>
              </template>
            </v-date-picker>
          </div>
          <label>End Date</label>
          <div class="col-span-4 mb-5">
            <v-date-picker
              class="date-picker w-full"
              is-dark
              :min-date="startDate"
              v-model="endDate"
              @dayclick="loadFilteredTable"
              is-required
            >
              <template v-slot="{ inputEvents }">
                <div class="date w-full">
                  <input
                    type="button"
                    class="date-input w-full text-left"
                    v-on="inputEvents"
                    :value="formattedEndDate"
                  />
                </div>
              </template>
            </v-date-picker>
          </div>
          <vs-button
            class="mt-3"
            color="#ffffff"
            text-color="#8d9498"
            @click="resetFilter"
            >รีเซ็ต</vs-button
          >
        </div>
      </div>
    </transition> -->
    <base-dialog :show="displayCreate" small>
      <div class="mx-5 my-5">
        <h2 class="text-white text-center">สร้างโฟลเดอร์</h2>
        <div class="grid grid-cols-12 gap-4">
          <input
            v-model="newFolderName"
            class="folder-name col-span-8 col-start-3 w-full my-5"
            type="text"
          />
          <vs-button
            class="col-end-7 col-span-4"
            color="#ffffff"
            text-color="#8d9498"
            @click="displayCreate = false"
            >ยกเลิก</vs-button
          >
          <vs-button
            class="col-end-11 col-span-4"
            color="#15c1c3"
            @click="createFolder"
            >บันทึก</vs-button
          >
        </div>
      </div>
    </base-dialog>
    <base-dialog :show="displayDelete" small>
      <div class="mx-5 my-5">
        <h4 class="text-white">ยืนยันการลบ{{ fileType }}นี้</h4>
        <div class="grid grid-cols-12 gap-4 mt-20">
          <vs-button
            class="col-end-9 col-span-4"
            color="#ffffff"
            text-color="#8d9498"
            @click="displayDelete = false"
            >ยกเลิก</vs-button
          >
          <vs-button
            class="col-end-13 col-span-4"
            color="#15c1c3"
            @click="confirmDeleteFile"
            >ยืนยัน</vs-button
          >
        </div>
      </div>
    </base-dialog>
    <base-dialog :show="displayPermission">
      <div class="px-8">
        <h2 class="text-white text-center my-5">
          จัดการสิทธิการเข้าถึง
        </h2>
        <div class="flex items-baseline">
          <h4>ชื่อ :&nbsp;</h4>
          <h4>{{ folderName }}</h4>
        </div>
        <div class="flex items-center my-4">
          <h4>ประเภทแอดมิน :&nbsp;</h4>
          <select
            class="w-2/12"
            v-model="roleId"
            @change="loadFolderPermission(modalFolderId)"
          >
            <option :value="null">ALL</option>
            <option
              v-for="role in roleList"
              :key="role.role_id"
              :value="role.role_id"
              >{{ role.role_name }}</option
            >
          </select>
        </div>
        <div class="pm-table">
          <div class="grid grid-cols-12 table-header">
            <div class="col-span-1">
              <vs-checkbox
                color="#57c293"
                :value="allIsView"
                @change="setAllView($event)"
                ><p>View</p></vs-checkbox
              >
            </div>
            <div class="col-span-1">
              <vs-checkbox
                color="#57c293"
                :value="allIsEdit"
                @change="setAllEdit($event)"
                ><p>Edit</p></vs-checkbox
              >
            </div>
            <div class="col-span-1">
              <p>รหัส</p>
            </div>
            <div class="col-span-7">
              <p>ชื่อ</p>
            </div>
            <div class="col-span-2">
              <p>สถานะ</p>
            </div>
          </div>
          <div v-if="this.userToFolder.length > 0" class="pm-row">
            <div
              v-for="user in userToFolder"
              :key="user.user_id"
              class="grid grid-cols-12 table-row"
            >
              <div class="col-span-1">
                <vs-checkbox color="#57c293" v-model="user.isView"
                  ><p>View</p></vs-checkbox
                >
              </div>
              <div class="col-span-1">
                <vs-checkbox color="#57c293" v-model="user.isEdit"
                  ><p>Edit</p></vs-checkbox
                >
              </div>
              <div class="col-span-1">
                <p>{{ user.user_id }}</p>
              </div>
              <div class="col-span-7">
                <p>{{ user.name }}</p>
              </div>
              <div class="col-span-2">
                <p>{{ user.role }}</p>
              </div>
            </div>
          </div>
          <div v-else class="pm-no-row">
            <p>No Rows To Show</p>
          </div>
        </div>
        <div class="grid grid-cols-8 gap-4 mt-5">
          <vs-button
            class="col-end-8"
            color="#ffffff"
            style="box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.09);"
            text-color="#8d9498"
            @click="closePermissionTable"
          >
            ยกเลิก
          </vs-button>
          <vs-button class="col-end-9" @click="submitPermission" color="#15c1c3"
            >บันทึก</vs-button
          >
        </div>
      </div>
    </base-dialog>
    <div class="contentArea">
      <div class="pl-2">
        <div>
          <!-- <topTableButton /> -->
          <!-- <tabComponent /> -->
          <div class="w-full">
            <div class="flex justify-between ml-3 date-filter">
              <div class="flex">
                <!-- <h1
                  v-for="path in folderLevelName"
                  :key="path.folderId"
                  class="text-white"
                  style="cursor: pointer;"
                  @click="goToFolder(path.folderId)"
                >
                  {{ path.name }}
                </h1> -->
                <div
                  class="folder-path"
                  v-for="path in folderLevelName"
                  :key="path.folderId"
                >
                  <h1>&nbsp;{{ path.name }}</h1>
                </div>
              </div>
              <div class="flex">
                <vs-button
                  v-if="adminCanEdit"
                  color="#15c1c3"
                  class="mr-3 px-px"
                  style="width: 160px;"
                  @click="displayCreate = true"
                >
                  <font-awesome-icon icon="file-import" class="mr-1" />
                  สร้างโฟลเดอร์
                </vs-button>
                <vs-button
                  v-if="adminCanEdit"
                  color="#15c1c3"
                  class="mr-3 px-px"
                  style="width: 140px;"
                  @click="$refs.fileInput.click()"
                >
                  <font-awesome-icon icon="file-import" class="mr-1" />
                  อัปโหลด
                </vs-button>
                <input
                  type="file"
                  name="image"
                  id="file"
                  style="display: none"
                  ref="fileInput"
                  @change="onSelectFile($event)"
                />
                <vs-button
                  color="#15c1c3"
                  class="mr-3 px-px"
                  style="width: 140px;"
                  @click="downloadSelected"
                >
                  <font-awesome-icon icon="file-import" class="mr-1" />
                  ดาวน์โหลด
                </vs-button>
                <!-- <vs-button
                  color="#f2a655"
                  class="mr-3 px-px"
                  style="width: 122px;"
                  type="border"
                  @click="filterDisplay = true"
                >
                  <font-awesome-icon
                    icon="filter"
                    class="mr-1"
                    :style="{ color: '#f2a655' }"
                  />
                  Filter by
                </vs-button> -->
                <div class="search flex items-center">
                  <font-awesome-icon
                    icon="search"
                    class="mr-1"
                    :style="{ color: '#03a9f3' }"
                  />
                  <input
                    type="text"
                    placeholder="Search"
                    v-model="searchTerm"
                  />
                </div>
              </div>
            </div>
            <AgGrid :searchQuery="searchTerm" ref="fileTable" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
import baseUrl from "../util/backend.js";
import fileUrl from "../util/backendfile.js";
import moment from "moment";
import { mapGetters } from "vuex";
import topTableButton from "../views/elements/topTableButton/topTableButton";
import AgGrid from "./elements/ag-grid-table/AgGridTable";
import AgTable from "../views/elements/ag-grid-table/table_component/tableOnly";
import tabComponent from "./elements/tabComponent/tabComponent";
import boardMain from "./elements/board/boardMain";
export default {
  data() {
    return {
      isLoading: false,
      showDialog: false,
      filterDisplay: false,
      displayCreate: false,
      displayDelete: false,
      displayPermission: false,
      deleteId: null,
      adminCanEdit: null,
      searchTerm: "",
      accountingList: [],
      bankPaymentList: [],
      memberList: [],
      modalCompany: null,
      selectedAccounting: null,
      // for filtering in modal
      monthSelected: 0,
      yearSelected: new Date().getFullYear(),
      // for filtering in filter by
      startDate: null,
      endDate: null,
      // for permission table modal
      modalFolderId: null,
      folderName: "",
      fileType: "",
      roleId: null,
      userToFolder: [],
      roleList: [],
      newFolderName: "",
    };
  },
  computed: {
    ...mapGetters({ nowSlug: "getNowSlug", tabActive: "general/tabActive" }),
    formattedStartDate() {
      if (this.startDate) {
        return moment(this.startDate).format("DD/MM/YYYY");
      } else {
        return null;
      }
    },
    formattedEndDate() {
      if (this.endDate) {
        return moment(this.endDate).format("DD/MM/YYYY");
      } else {
        return null;
      }
    },
    folderLevelName() {
      return this.$store.getters["create/getFolder"];
    },
    allIsView() {
      return this.userToFolder.every((v) => v.isView === true);
    },
    allIsEdit() {
      return this.userToFolder.every((v) => v.isEdit === true);
    },
  },
  components: {
    topTableButton,
    tabComponent,
    boardMain,
    AgGrid,
    AgTable,
    Loading,
  },
  mounted() {
    window.addEventListener("popstate", this.popFolderLevel);
    this.$root.$on("delete-modal", ({ id, type }) => {
      // this.testing(id);
      this.displayDelete = true;
      this.fileType = type;
      this.deleteId = id;
    });
    // this.$root.$on("show-file", this.test({ id, folderName, type }));
    this.$root.$on("show-file", ({ id, folderName, type }) => {
      this.folderName = folderName;
      this.fileType = type;
      this.loadFolderPermission(id);
    });
    this.loadFolderTable();
  },
  watch: {
    $route() {
      this.loadFolderTable();
    },
    startDate() {
      if (this.endDate) {
        if (this.endDate < this.startDate) {
          this.endDate = this.startDate;
        }
      }
    },
  },
  methods: {
    test(id, folderName, type) {},
    closeFilter() {
      this.filterDisplay = false;
    },
    resetFilter() {
      this.startDate = null;
      this.endDate = null;
      this.$store.dispatch("general/getTable", "third");
    },
    closePermissionTable() {
      this.roleId = null;
      this.displayPermission = false;
    },
    async createFolder() {
      this.isLoading = true;
      const fileRes = await axios.get(
        `${fileUrl}/folder/get/id?folder_id=${this.$route.params.id}`
      );
      console.log("fileRes", fileRes.data.data.Folder.folder);
      const fileDir = fileRes.data.data.Folder.folder;
      const createRes = await axios.post(
        `${baseUrl}/file/folder/create`,
        {
          parent_folder_id: this.$route.params.id,
          folder_level: fileDir.folder_level_id + 1,
          folder_name: this.newFolderName,
        },
        {
          headers: {
            Authorization: this.$store.getters.getToken,
          },
        }
      );
      console.log(createRes);
      if (createRes.data.status === "success") {
        this.displayCreate = false;
        this.newFolderName = "";
        await this.loadFolderTable();
      } else {
        alert(createRes.data.message);
      }
      this.isLoading = false;
    },
    async onSelectFile(e) {
      console.log(e.target.files[0]);
      console.log(e.target.value.split(/(\\|\/)/g).pop());
      const formData = new FormData();
      formData.append("folder_id", this.$route.params.id);
      formData.append("file", e.target.files[0]);
      const res = await axios.post(`${fileUrl}/file/create`, formData);
      console.log(res.data.data.uploadFileAtLevel.file_id);
      const permissionRes = await axios.post(
        `${baseUrl}/file/file/create`,
        {
          file_id: res.data.data.uploadFileAtLevel.file_id,
        },
        {
          headers: {
            Authorization: this.$store.getters.getToken,
          },
        }
      );
      console.log(permissionRes);
      this.loadFolderTable();
    },
    async confirmDeleteFile() {
      this.isLoading = true;
      let link = "";
      if (this.fileType === "File") {
        link = `${baseUrl}/file/delete?file_id=${this.deleteId}`;
      }
      if (this.fileType === "Folder") {
        link = `${baseUrl}/file/delete?folder_id=${this.deleteId}`;
      }
      const res = await axios.post(
        link,
        {},
        {
          headers: {
            Authorization: this.$store.getters.getToken,
          },
        }
      );
      console.log(res);
      await this.loadFolderTable();
      this.displayDelete = false;
      this.isLoading = false;
    },
    getFile(url, title) {
      console.log("url", url);
      axios({
        method: "get",
        url,
        responseType: "arraybuffer",
        // headers: { "Access-Control-Allow-Origin": "*" },
      })
        .then((response) => {
          this.forceFileDownload(response, title);
        })
        .catch(() => console.log("error occured"));
    },
    forceFileDownload(response, title) {
      console.log(title);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", title);
      document.body.appendChild(link);
      link.click();
    },
    timeout(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async downloadSelected() {
      const selectedFile = this.$refs.fileTable.getSelectedRowData();
      console.log(selectedFile);
      // const linkArr = [];
      for await (const select of selectedFile) {
        if (select.type === "File") {
          await this.timeout(500);
          this.getFile(select.file_url, select.name);
        }
        if (select.type === "Folder") {
          for await (const file of select.folder_file) {
            await this.timeout(500);
            this.getFile(file.url, file.name);
          }
        }
      }
    },
    async loadFolderTable() {
      this.isLoading = true;
      await this.$store.dispatch("general/getFilteredFolderTable", {
        path: "ninth",
        folderId: this.$route.params.id,
        userId: this.$store.getters.getUserId,
      });
      this.loadAdminPermission();
      this.isLoading = false;
    },
    setAllView(e) {
      if (e.target.checked) {
        for (const user of this.userToFolder) {
          user.isView = true;
        }
      } else {
        for (const user of this.userToFolder) {
          user.isView = false;
        }
      }
    },
    setAllEdit(e) {
      if (e.target.checked) {
        for (const user of this.userToFolder) {
          user.isEdit = true;
        }
      } else {
        for (const user of this.userToFolder) {
          user.isEdit = false;
        }
      }
    },
    goToFolder(id) {
      const index = this.folderLevelName.findIndex((v) => v.folderId === id);
      console.log("index", index);
      const newLevel = [];
      for (let i = 0; i <= index; i++) {
        newLevel.push(this.folderLevelName[i]);
      }
      this.$store.dispatch("create/skipFolder", newLevel);
      this.$router.replace(`/foldermanagement/${id}`);
    },
    popFolderLevel() {
      this.$store.dispatch("create/popFolderLevelName");
    },
    async submitPermission() {
      console.log(this.userToFolder);
      const permissionData = [];
      if (this.fileType === "Folder") {
        for (const user of this.userToFolder) {
          permissionData.push({
            user_id: user.user_id,
            folder_id: this.modalFolderId,
            isView: user.isView,
            isEdit: user.isEdit,
          });
        }
        const res = await axios.post(
          `${baseUrl}/file/folder`,
          {
            user: permissionData,
          },
          {
            headers: {
              Authorization: this.$store.getters.getToken,
            },
          }
        );
        console.log(res);
      } else {
        for (const user of this.userToFolder) {
          permissionData.push({
            user_id: user.user_id,
            file_id: this.modalFolderId,
            isView: user.isView,
            isEdit: user.isEdit,
          });
        }
        const res = await axios.post(
          `${baseUrl}/file/file`,
          {
            user: permissionData,
          },
          {
            headers: {
              Authorization: this.$store.getters.getToken,
            },
          }
        );
        console.log(res);
      }
      this.modalFolderId = null;
      this.userToFolder = [];
      this.displayPermission = false;
    },
    async loadFolderPermission(id) {
      this.modalFolderId = id;
      if (this.fileType === "Folder") {
        if (this.roleId) {
          const res = await axios.get(
            `${baseUrl}/file/folder/get?folder_id=${id}&role_id=${this.roleId}`,
            {
              headers: {
                Authorization: this.$store.getters.getToken,
              },
            }
          );
          // console.log(res);
          this.userToFolder = res.data.data;
        } else {
          const res = await axios.get(
            `${baseUrl}/file/folder/get?folder_id=${id}`,
            {
              headers: {
                Authorization: this.$store.getters.getToken,
              },
            }
          );
          console.log(res);
          this.userToFolder = res.data.data;
        }
      } else {
        if (this.roleId) {
          const res = await axios.get(
            `${baseUrl}/file/file/get?file_id=${id}&role_id=${this.roleId}`,
            {
              headers: {
                Authorization: this.$store.getters.getToken,
              },
            }
          );
          console.log(res);
          this.userToFolder = res.data.data;
        } else {
          const res = await axios.get(
            `${baseUrl}/file/file/get?file_id=${id}`,
            {
              headers: {
                Authorization: this.$store.getters.getToken,
              },
            }
          );
          console.log(res);
          this.userToFolder = res.data.data;
        }
      }
      this.displayPermission = true;
    },
    async loadRoleList() {
      const res = await axios.get(`${baseUrl}/role/get`, {
        headers: {
          Authorization: this.$store.getters.getToken,
        },
      });
      this.roleList = res.data.data;
    },
    async loadAdminPermission() {
      const res = await axios.get(
        `${baseUrl}/file/folder/get?folder_id=${this.$route.params.id}&user_id=${this.$store.getters.getUserId}`,
        {
          headers: {
            Authorization: this.$store.getters.getToken,
          },
        }
      );
      this.adminCanEdit = res.data.data[0].isEdit;
    },
  },
  created() {
    this.$store.dispatch("create/setFolderLevelName", {
      name: "All Files",
      folderId: this.$route.params.id,
    });
    this.loadRoleList();
  },
  beforeDestroy() {
    window.removeEventListener("popstate", this.popFolderLevel);
    this.$store.dispatch("create/clearFolderLevel");
  },
  beforeRouteUpdate(_, _2, next) {
    if (this.isLoading) {
      next(false);
    } else {
      next();
    }
  },
  beforeRouteLeave(_, _2, next) {
    if (this.isLoading) {
      next(false);
    } else {
      next();
    }
  },
};
</script>

<style scoped>
.search input[type="text"] {
  font-size: 17px;
  border: none;
  border-radius: 2px;
  background-color: #3a3f51;
  width: 100px;
  color: #dddddd;
  padding: 10px 5px;
  transition: width 0.5s;
}

.search input[type="text"]:focus {
  width: 300px;
}

.search {
  padding-left: 10px;
  border-radius: 5px;
  border: solid 1.5px #03a9f3;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #03a9f3;
  opacity: 1; /* Firefox */
}

h2,
h4 {
  color: #dddddd;
}

.folder-name {
  border: none;
  border-radius: 2px;
  background-color: #434f5b;
  color: #dddddd;
  width: 122px;
  padding: 8px 10px;
  font-size: 16px;
}

.filter {
  position: absolute;
  right: 0;
  z-index: 1000000;
  background-color: #4e5363;
  width: 20%;
  height: 100vh;
}

.close {
  cursor: pointer;
  margin-top: 8px;
  margin-left: 8px;
  width: 15px;
  height: auto;
}

.filter-header {
  padding: 10px;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.09);
}

.filter-input {
  padding: 20px;
}

input[type="button"] {
  height: 34px;
  min-width: 0;
  border-radius: 5px;
  background: #3a3f51;
  border: none;
  color: #ffffff;
  font-size: 17px;
  padding-left: 10px;
}

.right-enter,
.right-leave-to {
  opacity: 0;
  right: -320px;
}

.right-enter-active {
  transition: all 0.3s ease-out;
}

.right-leave-active {
  transition: all 0.3s ease-in;
}

.right-enter-to,
.right-leave {
  opacity: 1;
  right: 0;
}

/* for downloading */
.download-form {
  font-family: Kanit, Helvetica, Arial, sans-serif !important;
  font-size: 17px;
}

p {
  color: #fff;
}

select {
  height: 34px;
  border-radius: 2px;
  padding-left: 10px;
  font-size: 16px;
  color: #fff;
  background-color: #434f5b;
  border: none;
}

.pm-table {
  background-color: #4e5363;
  padding: 10px;
  border-radius: 5px;
}

.pm-row {
  overflow-y: scroll;
  height: 200px;
}

.pm-no-row {
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pm-row::-webkit-scrollbar {
  display: none;
}

.table-header {
  padding-bottom: 10px;
  border-bottom: 1px solid #8d9498;
}

.table-row {
  padding: 10px 0;
}

h1 {
  color: #dddddd;
}

.folder-path {
  opacity: 0.5;
}

.folder-path:last-child {
  opacity: 1;
}
</style>
